


const useTitle = (title)=>{
    document.title = title;
}

export default useTitle;

